import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'dhlRed' | 'goGreen' | 'error' | 'inherit'>
}>

/**
 * Demos:
 * - [H6](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/primitives-typography--h-6)
 *
 */

export const H6 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="h6" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
